import { FormControlLabel, FormGroup, IconButton, Paper } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import matchSorter from 'match-sorter';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';


// Define a default UI for filtering
export function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
}) {
    //const count = preGlobalFilteredRows.length

    return (
        <div className='global-table-filter'>
            <input
                value={globalFilter || ''}
                onChange={e => {
                    setGlobalFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
                }}
                placeholder='Keresés'
            />
        </div>
    )
}

// Define a default UI for filtering
export function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    //const count = preFilteredRows.length
    const [value, setValue] = useState(filterValue || '');

    const handleClick = (res) => {
        setValue('');
        setFilter('');
    }

    return (
        <>
            <input className="columnSearch"
                value={value}
                onChange={e => {
                    setValue(e.target.value || undefined)
                    setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
                }}
                placeholder={`Keresés `}
            />
            {value ? <span className="lnr lnr-cross" onClick={handleClick} /> : <></>}
        </>
    )
}

// This is a custom filter UI for selecting
// a unique option from a list
export function SelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            if (typeof row.values[id] === 'boolean') {
                options.add(row.values[id].toString())
            } else {
                options.add(row.values[id])
            }
        })
        return [...options.values()]
    }, [id, preFilteredRows])

    const [value, setValue] = useState(filterValue || '');

    const handleClick = (res) => {
        setValue('');
        setFilter('');
    }

    const handleSelect = (e) => {
        setFilter(e.target.value || undefined)
        setValue(e.target.value || undefined);
    }

    // Render a multi-select box
    return (
        <>
            <select
                className='columnSearch'
                value={value}
                onChange={handleSelect}
            >
                <option value="">Mind</option>
                {options.map((option, i) => (
                    <option key={i} value={option}>
                        {option}
                    </option>
                ))}
            </select>
            {value ? <span className="lnr lnr-cross" onClick={handleClick} /> : <></>}
        </>
    )
}

export function SelectColumnFilterNew({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            if (typeof row.values[id] === 'boolean') {
                options.add(row.values[id].toString())
            } else {
                options.add(row.values[id])
            }
        })
        return [...options.values()]
    }, [id, preFilteredRows])

    // const [value, setValue] = useState(filterValue || '');
    const [valueList, setValueList] = useState([]);
    const [checked, setChecked] = useState(Array.from(options));

    const handleClick = (res) => {
        setValueList([]);
        setFilter('');
    }

    const handleChange = (event) => {
        console.log(checked)
        // setValueList(event.target.value);
        // setFilter(checked);
    };

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
        setFilter(newChecked);
        console.log('checked:' + checked)
        console.log('valueList' + valueList)
    };

    // Render a multi-select box
    return (
        <>
            <Select
                displayEmpty
                className='columnSearch'
                value={checked}
                onChange={handleChange}
                multiple
            >
                {/* <option value="">Mind</option>
                {options.map((option, i) => (
                    <option key={i} value={option}>
                        {option}
                    </option>
                ))} */}

                {/* <MenuItem key="all" value="">Mind</MenuItem>
                {options.map((option, i) => (
                    <MenuItem key={i} value={option}>
                        {option}
                    </MenuItem>
                ))} */}
                <FormGroup>
                    {/* <MenuItem key="all" value="">Mind</MenuItem> */}
                    {options.map((option, i) => (
                        // <Combobox label={option} key={option} checked={checked} onChange={onChange}/>
                        <FormControlLabel
                            control={<Checkbox checked={checked.indexOf(option) !== -1} onChange={handleToggle(option)} name={option} value={option} color="primary" />}
                            label={option}
                        />
                    ))}
                </FormGroup>

            </Select>
            {checked && checked.length > 0 ? <span className="lnr lnr-cross" onClick={handleClick} /> : <></>}
        </>
    )
}

export function SelectColumnFilterAutocomplete({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            if (typeof row.values[id] === 'boolean') {
                options.add(row.values[id].toString())
            } else {
                options.add(row.values[id])
            }
        })
        return [...options.values()]
    }, [id, preFilteredRows])

    const onChange = (event, value) => {
        setFilter(value);
    };

    // Render a multi-select box
    return (
        <Autocomplete
            //multiple
            className='autocompleteFilter'
            id="checkboxes-tags-demo"
            limitTags={1}
            size='small'
            options={options}
            dense={true}
            disableCloseOnSelect
            onChange={onChange}
            getOptionLabel={(option) => option}
            renderOption={(option, { selected }) => (
                <div className='proba'>
                    <Checkbox
                        className='probaCheckbox'
                        //icon={icon}
                        //checkedIcon={checkedIcon}
                        //style={{ marginRight: 8 }}
                        size='small'
                        checked={selected}
                        margin="dense"
                    />
                    {option}
                </div>
            )}
            PaperComponent={DropDownList}
            // renderInput={(params) => (
            //     <TextField {...params} placeholder="Keresés" /> //{...params} margin="dense"
            // )}
            // renderInput={(params) => (
            //     <div ref={params.InputProps.ref}>
            //         <input type="text" {...params.inputProps} />
            //     </div>
            // )}
            renderInput={InputRendered}
        />
    )
}

function InputRendered(params) {
    return (
        <div ref={params.InputProps.ref}>
            <IconButton>

            </IconButton>
            {/* <input type="text" {...params.inputProps} onClick={onClick} /> */}
        </div>
    )
};

const DropDownList = ({ children, ...other }) => (
    <div className="dropDownList">
        <Paper {...other} variant='elevation'>
            {children}
        </Paper>
    </div>
);

export function SelectColumnFilter2({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            if (typeof row.original[id] === 'boolean') {
                options.add(row.original[id].toString())
            } else if (row.original[id] && typeof row.original[id] !== 'string') {
                options.add(row.original[id].toString())
            } else {
                options.add(row.original[id])
            }
        })
        return [...options.values()]
    }, [id, preFilteredRows])

    // Render a multi-select box
    return (
        <select
            className='columnSearch'
            value={filterValue}
            onChange={e => {
                setFilter(e.target.value || undefined)
            }}
        >
            <option value="">Mind</option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </select>
    )
}

//szar
export function MultiSelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Map()
        preFilteredRows.forEach(row => {
            if (typeof row.values[id] === 'boolean') {
                options.set(row.values[id].toString(), true)
            } else {
                options.set(row.values[id], true)
            }
        })
        return [...options];
    }, [id, preFilteredRows])

    const changeCheck = (e) => {
        console.log(options);
    }

    const handleChange = (e) => {
    }
    console.log(options)
    // Render a multi-select box
    return (

        <Select
            labelId="demo-mutiple-checkbox-label"
            id="demo-mutiple-checkbox"
            multiple
            value={[filterValue]}
            onChange={handleChange}
            input={<Input />}
        //renderValue={(selected) => selected.join(', ')}
        >
            {options.map((name, bool) => (
                <MenuItem key={name} value={name}>
                    <Checkbox checked={options.indexOf(name)} onClick={changeCheck(name)} />
                    <ListItemText primary={name} />
                </MenuItem>
            ))}
        </Select>
    )
}

export function MultiSelectFilterFn(rows, id, filterValues) {
    if (filterValues.length === 0) return rows;

    return rows.filter(r => filterValues.includes(r.values[id]));
}

export function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
    return rows.filter(row => {
        const rowValue = row.values[id]
        return rowValue >= filterValue
    })
}

// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number
filterGreaterThan.autoRemove = val => typeof val !== 'number'

export function booleanFilter(rows, id, filterValue) {
    return rows.filter(row => {
        const rowValue = row.values[id].toString()
        return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
    })
}


// This is a custom filter UI for selecting
// a unique option from a list
export function DatePickerColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    const [value, setValue] = React.useState(filterValue)
    const [operation, setOperation] = React.useState()

    const handleValueChange = (value) => {
        setValue(value);
        setFilter(value || undefined)
    }

    //Date.prototype.addHours = function(h) {
    //    this.setTime(this.getTime() + (h*60*60*1000));
    //    return this;
    //  }

    // Render a multi-select box
    return (
        <>
            <select
                value={operation}
                onChange={e => {
                    setOperation(e.target.value || undefined)
                }}
            >
                <option value="0">=</option>
                <option value="1">&gt;</option>
                <option value="-1">&#60;</option>

            </select>
            <DatePicker
                selected={value}
                onChange={handleValueChange}
                dateFormat="yyyy. MM. dd."
                isClearable
            />
        </>
    )
}

export function dateFilter(rows, id, filterValue) {
    console.log(id);
    console.log(filterValue);
    if (filterValue) {
        return rows.filter(row => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? _.isEqual(rowValue.toDateString(), filterValue.toDateString())
                : true
        })
    } else {
        return true;
    }
}